<template>
  <div class="lv-dashboard-number-card">
    <div
      v-if="buttonIcon || buttonImg"
      class="lv-dashboard-number-card__btn-wrap"
      @click="$_btnClick()"
    >
      <i v-if="buttonIcon" class="lv-dashboard-number-card__btn" :class="buttonIcon" />
      <img v-if="buttonImg" :src="buttonImg" alt="" class="lv-dashboard-number-card__btn image" />
    </div>
    <div class="lv-dashboard-number-card_title-wrap">
      <WsRow>
        <i class="lv-dashboard-number-card_title-icon mr-10" :class="titleIcon" />
        <WsText001 h4>
          {{ $t(title) }}
        </WsText001>
      </WsRow>
      <div v-if="!isLoading" class="total-number">
        <WsText001 h2 bold class="mt-10">
          {{ totalNumber }}
        </WsText001>
        <div class="total-number__tooltips">
          {{ $t(totalNumberToolTips) }}
        </div>
      </div>
    </div>
    <DotLoading v-if="isLoading" />
    <div v-else>
      <div v-if="numberInfos" class="number-infos mb-8">
        <LvFlexBox justifyContent="space-between" width="100%" :gap8="false">
          <WsTextButton001
            v-if="multiSystemClasses && multiSystemClasses.length"
            primary
            no-padding
            :leading-icon="_hideZeroToggleIcon"
            @click="$_onToggleHideZero"
          >
            {{ $t(_hideZeroToggleText) }}
          </WsTextButton001>
          <LvFlexBox justifyContent="flex-end" :gap8="false">
            <div
              v-for="(info, infoIndex) in numberInfos"
              :key="infoIndex"
              class="number-info"
              @mouseover="$_onHoverIcon($event)"
            >
              <LvText h5 bold>
                {{ $t(info.numberTag) }}
                <i class="icon-info mt-2 ml-2" />
              </LvText>
              <div
                class="number-info__tooltips"
                :style="{
                  top: toolTip.top,
                  left: toolTip.left,
                }"
              >
                {{ $t(info.toolTips) }}
              </div>
            </div>
          </LvFlexBox>
        </LvFlexBox>
      </div>
      <div v-if="multiSystemClasses && multiSystemClasses.length > 0">
        <div
          v-for="(multiSystemClass, multiSystemClassIndex) in multiSystemClasses"
          :key="multiSystemClass.id"
        >
          <LvText bold>{{ multiSystemClass.title }}</LvText>
          <div class="lv-dashboard-number-card_content">
            <div
              v-for="system_e in $_filteredClassList(multiSystemClass.classList)"
              :key="system_e.id"
              class="content-list"
            >
              <div v-if="system_e.icon" class="leading-icon">
                <i :class="system_e.icon" />
              </div>
              <div v-if="system_e.image" class="leading-image">
                <img :src="system_e.image" alt="" />
              </div>
              <p class="content-text">
                {{ $t(system_e.systemTitle) }}
              </p>
              <p
                class="content-text number ml-auto"
                :class="{ disable: parseInt(system_e.number1) == 0 }"
                @click="numberClick(system_e, 'number1')"
              >
                {{ system_e.number1 }}
              </p>
              <p
                class="content-text number"
                :class="{ disable: parseInt(system_e.number2) == 0 }"
                @click="numberClick(system_e, 'number2')"
              >
                {{ system_e.number2 }}
              </p>
            </div>
          </div>
          <LvDivider v-if="multiSystemClassIndex !== multiSystemClasses.length - 1" />
        </div>
      </div>
      <div v-for="(bigNum, bigNumIndex) in bigNumber" :key="bigNumIndex" class="info-number__big">
        <div class="info-number__big-info">
          <WsText001 remark bold>
            {{ $t(bigNum.title) }}
            <i class="icon-info mt-2 ml-2 icon" />
            <div class="info-number__big-tooltips">
              {{ $t(bigNum.tooltips) }}
            </div>
          </WsText001>
        </div>
        <div class="info-number__big-num" @click="numberClick(bigNum, `number${bigNumIndex + 1}`)">
          <WsText001
            h2
            bold
            class="mt-10"
            :class="{ disable: $_bigNum(bigNum, bigNumIndex + 1) == 0 }"
          >
            {{ $_bigNum(bigNum, bigNumIndex + 1) }}
          </WsText001>
        </div>
      </div>
      <div v-if="_updatedAt || bottomText" class="lv-dashboard-number-card__bottom">
        <div>{{ _updatedAt }}</div>
        <div>{{ $t(bottomText) }}</div>
      </div>
      <div v-if="isDisable" class="lv-diagram-card__disable">
        <i class="lv-diagram-card__disable-icon" :class="disableIcon" />
        <div class="lv-diagram-card__disable-text">
          {{ $t(disableText) }}
        </div>
        <div v-if="disableBtnText" class="lv-diagram-card__disable-btn">
          <WsButton001 width-stretch @click="$_disableClick()">
            {{ $t(disableBtnText) }}
          </WsButton001>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DashboardNumberCard',
  props: {
    value: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    titleIcon: {
      type: String,
      default: '',
    },
    totalNumber: {
      type: Number,
      default: 0,
    },
    totalNumberToolTips: {
      type: String,
      default: '',
    },
    systemType: {
      type: Array,
      default() {
        return [];
      },
    },
    numberInfos: {
      type: Array,
      default() {
        return [];
      },
    },
    bigNumber: {
      type: Array,
      default() {
        return [];
      },
    },
    buttonIcon: {
      type: String,
      default: 'icon-arrow-go',
    },
    buttonImg: {
      type: String,
      default: '',
    },
    updatedAt: {
      type: String,
      default: '',
    },
    bottomText: {
      type: String,
      default: '',
    },
    isDisable: {
      type: Boolean,
      default: false,
    },
    disableIcon: {
      type: String,
      default: 'icon-lock',
    },
    disableText: {
      type: String,
      default: '',
    },
    disableBtnText: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    multiSystemClasses: {
      type: Array,
    },
  },
  data() {
    return {
      toolTip: {
        top: '0',
        left: '0',
      },
      hideZeroItems: true,
    };
  },
  computed: {
    _updatedAt() {
      if (!this.updatedAt) return '';
      return `${this.$t('更新時間')} ${this.$moment(this.updatedAt).format('YYYY-MM-DD HH:mm:ss')}`;
    },
    _hideZeroToggleIcon() {
      return this.hideZeroItems ? 'icon-eye-close' : 'icon-eye-open';
    },
    _hideZeroToggleText() {
      return this.hideZeroItems ? '顯示全部' : '隱藏為0項目';
    },
  },
  methods: {
    $_onToggleHideZero() {
      this.hideZeroItems = !this.hideZeroItems;
    },
    $_filteredClassList(classList) {
      if (!this.hideZeroItems || !classList) return classList;
      return classList.filter(item => parseInt(item.number1) !== 0 || parseInt(item.number2) !== 0);
    },
    $_btnClick() {
      this.$emit('btn-click');
    },
    numberClick($event, item) {
      if (!parseInt($event[item])) {
        return;
      }
      const _item = {
        value: this.value,
        data: $event,
        item: item,
      };
      this.$emit('number-click', _item);
    },
    $_bigNum(data, index) {
      const _key = 'number' + `${index}`;
      return data[_key];
    },
    $_onHoverIcon(e) {
      if (e.currentTarget.classList.contains('number-info')) {
        const toolTipH = e.currentTarget
          .querySelector('.number-info__tooltips')
          .getBoundingClientRect().height;
        const width = e.currentTarget.getBoundingClientRect().width;
        this.toolTip = {
          top: `${-toolTipH}px`,
          left: `${width / 2 - 50}px`,
        };
      }
    },
  },
};
</script>
